module.exports = __webpack_public_path__ + "img/anime-four.06f8fcb4.png";